// firebase.js - Firebase configuration
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup, signInWithRedirect, getRedirectResult, signOut } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCi3S9Qw3oZ8QdPGc5CQ9bZyrV6K297F7o",
  authDomain: "nethaji-prime-ott.firebaseapp.com",
  projectId: "nethaji-prime-ott",
  storageBucket: "nethaji-prime-ott.firebasestorage.app",
  messagingSenderId: "513916374374",
  appId: "1:513916374374:web:b4d236e45d9124c2b6cca7",
  measurementId: "G-ZEYK33BPZV"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

export const signInWithGoogle = async () => {
  const result = await signInWithPopup(auth, googleProvider);
  return result.user;
};

export const signOutGoogle = async () => {
  await signOut(auth);
};

